import React from 'react';

interface LineTrashIconProps {
  size?: number;
  color?: string;
}

export const LineTrashIcon: React.FC<LineTrashIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.0801 7L18.9971 8.07715L18.1445 19.1533C18.0644 20.1952 17.1962 20.9998 16.1514 21H7.84863C6.80377 20.9998 5.93561 20.1952 5.85547 19.1533L5.00293 8.07715L4.91992 7H19.0801Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M16.2568 7L15.9746 5.77539L15.6914 4.5498C15.4818 3.64269 14.6742 3.0001 13.7432 3H10.2568C9.3258 3.0001 8.51818 3.64269 8.30859 4.5498L8.02539 5.77539L7.74316 7H16.2568Z"
        stroke={color}
        strokeWidth="2"
      />
      <rect x="9" y="10" width="2" height="7" rx="1" fill={color} />
      <rect x="13" y="10" width="2" height="7" rx="1" fill={color} />
      <rect x="2" y="6" width="20" height="2" rx="1" fill={color} />
    </svg>
  );
};
